import WrapperLayout from 'components/Layout';
import FindPeople from './components/FindPeople';
const FindLeads = () => {
    return (
        <WrapperLayout>
            <FindPeople/>
        </WrapperLayout>
    )
}
export default FindLeads